import "./LoadingSpinner.scss";
export default function LoadingSpinner() {
  return <div className="global-loading active">
    <div className="spinner"></div>
    <div className="loading-text">Loading</div>
  </div>;
}